import React from 'react';
import Icon from '../../../components/AppIcon';

const StatusCard = ({ 
  status = 'recepcionado',
  count = 0,
  label = '',
  onClick
}) => {
  const statusConfig = {
    recepcionado: {
      icon: 'ClipboardList',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20',
      hoverBg: 'hover:bg-primary/20'
    },
    inspeccionado: {
      icon: 'Search',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/20',
      hoverBg: 'hover:bg-accent/20'
    },
    cotizando: {
      icon: 'FileText',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      borderColor: 'border-secondary/20',
      hoverBg: 'hover:bg-secondary/20'
    },
    aprobado: {
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20',
      hoverBg: 'hover:bg-success/20'
    },
    enproceso: {
      icon: 'Wrench',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20',
      hoverBg: 'hover:bg-warning/20'
    },
    terminado: {
      icon: 'CheckCircle2',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20',
      hoverBg: 'hover:bg-success/20'
    },
    entregado: {
      icon: 'Package',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20',
      hoverBg: 'hover:bg-primary/20'
    },
    cancelado: {
      icon: 'XCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/20',
      hoverBg: 'hover:bg-error/20'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.recepcionado;

  return (
    <button
      onClick={onClick}
      className={`
        w-full bg-card rounded-lg border ${config?.borderColor}
        shadow-elevation-1 p-4 md:p-6
        transition-smooth hover-lift press-effect focus-ring
        ${config?.hoverBg}
      `}
    >
      <div className="flex items-center justify-between mb-3 md:mb-4">
        <div className={`p-2 md:p-3 rounded-lg ${config?.bgColor}`}>
          <Icon name={config?.icon} size={20} className={config?.color} />
        </div>
        <span className={`text-2xl md:text-3xl lg:text-4xl font-heading font-bold ${config?.color} data-text`}>
          {count}
        </span>
      </div>
      <h3 className="text-sm md:text-base font-body font-medium text-foreground text-left">
        {label}
      </h3>
    </button>
  );
};

export default StatusCard;